export default function useIsISO8061(date: string) {
  return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:-\d{2}:\d{2}|Z)?$/.test(
    date,
  )
}
